module.exports = __webpack_public_path__ + "static/media/societies.e7a990fc.jpg";